import { useEffect, useRef } from "react";
import styles from "./styles/GamePlay.module.css";
import PlayWire from "../../components/common/play-wire";
import {
  ADS_PROVIDER_YANDEX,
  ADS_PROVIDER_ADSENSE,
  ADS_PROVIDER_PLAYWIRE,
  ADS_PROVIDER_GAM,
  useSiteData,
} from "../../redux/siteData";
import StickyAd from "./StickyAd";
import AdSense from "@/components/common/ad-sense";
import { shouldCountPlaywirePageview } from "@/lib/playwire";
// import AdSense from "../../components/common/ad-sense";
// import StickyAdsenseAd from "../../components/StickyAdsenseAd";

const pwUnits = [
  {
    selectorId: "game_skyscraper_desktop",
    type: "sky_atf",
  },
];

const pwUnitsMobile = [
  {
    selectorId: "game_sticky_bottom_mobile",
    type: "leaderboard_btf",
  },
];

async function initPlayWire(isDesktop: boolean) {
  if (typeof window.ramp?.spaAds === "function") {
    const units = isDesktop ? pwUnits : pwUnitsMobile;
    try {
      await window.ramp.spaAds({
        ads: units,
        countPageview: shouldCountPlaywirePageview(),
        path: "ROS",
      });
    } catch (error) {
      console.log(error);
    }
  }
}

const GAM_SIZE_DESKTOP = [[160, 600]];
const GAM_SIZE_MOBILE = [[320, 50]];

let GAM_SLOT_DESKTOP = "/22528994871/ch_game_left_rail";
let GAM_SLOT_MOBILE = "/22528994871/ch_game_mobile_bottom";
let GAM_ID_DESKTOP = "div-ch_game_left_rail";
let GAM_ID_MOBILE = "div-ch_game_mobile_bottom";

function initGAM(slotRef: any, isDesktop: boolean) {
  if (!window.googletag?.cmd || !isDesktop) return;

  let GAM_SLOT = GAM_SLOT_MOBILE;
  let GAM_ID = GAM_ID_MOBILE;
  let GAM_SIZE = GAM_SIZE_MOBILE;

  if (isDesktop) {
    GAM_SLOT = GAM_SLOT_DESKTOP;
    GAM_ID = GAM_ID_DESKTOP;
    GAM_SIZE = GAM_SIZE_DESKTOP;
  }

  window.googletag.cmd.push(() => {
    const slot = window.googletag
      .defineSlot(GAM_SLOT, GAM_SIZE, GAM_ID)
      ?.addService(window.googletag.pubads());

    if (!slot) return;
    slotRef.current = slot;

    window.googletag.display(GAM_ID);
  });
}

function initYandex(isDesktop) {
  const obj = isDesktop
    ? {
      renderTo: "yandex_rtb_R-A-1674804-1",
      blockId: "R-A-1674804-1",
    }
    : {
      renderTo: "yandex_rtb_R-A-1674804-3",
      blockId: "R-A-1674804-3",
    };

  window.yaContextCb.push(() => {
    window.Ya.Context.AdvManager.render(obj);
  });
}

export default function GameAd({ isDesktop }) {
  const { adsVisible, adsProvider } = useSiteData();
  const slotRef = useRef<any | null>(null);
  useEffect(() => {
    if (!adsVisible || isDesktop === null) {
      return;
    }

    if (adsProvider === ADS_PROVIDER_PLAYWIRE) {
      initPlayWire(isDesktop);
    } else if (adsProvider === ADS_PROVIDER_YANDEX) {
      initYandex(isDesktop);
    } else if (adsProvider === ADS_PROVIDER_GAM) {
      initGAM(slotRef, isDesktop);
      return () => {
        if (!window.googletag?.cmd || !slotRef.current) return;

        window.googletag.cmd.push(() => {
          window.googletag.destroySlots([slotRef.current]);
        });

        slotRef.current = null;
      };
    }
  }, [adsVisible, adsProvider, isDesktop]);

  return isDesktop ? (
    <div className="flex flex-col h-auto md:h-[600px] w-full md:w-[160px] mt-4 md:mt-0 justify-center mr-0 md:mr-[20px] overflow-hidden">
      {adsProvider === ADS_PROVIDER_PLAYWIRE ? (
        <div
          id="game_skyscraper_desktop"
          className="hidden md:flex md:h-[650px] w-[160px] overflow-hidden justify-center"
        />
      ) : adsProvider === ADS_PROVIDER_GAM ? (
        <div
          id={GAM_ID_DESKTOP}
          className="hidden md:flex md:h-[600px] w-[160px] overflow-hidden justify-center"
        ></div>
      ) : adsProvider === ADS_PROVIDER_ADSENSE ? (
        <AdSense
          adStyles="hidden md:flex md:h-[600px] w-[160px] overflow-hidden justify-center"
          showRemoveAds={false}
          slot="7152821243"
          format="auto"
          insStyle={{ width: "100%" }}
        />
      ) : (
        <div
          className="hidden md:flex md:h-[600px] w-[160px] overflow-hidden justify-center"
          id="yandex_rtb_R-A-1674804-1"
        ></div>
      )}
    </div>
  ) : (
    <StickyAd adsProvider={adsProvider} />
  );
}
